<template>
  <div v-if="validAverage" class="star-rating" :aria-label="ariaLabelForRatings" role="img">
    <span v-for="index in fullStarCount" :key="index" class="star-rating__star icon-star_filled"></span>

    <span v-if="!fullStarMaxedOut">
      <span v-if="!isAverageWholeNumber">
        <span v-if="hasHalfStar" class="star-rating__star icon-star_half"></span>
        <span v-else class="star-rating__star icon-star_filled"></span>
      </span>

      <span v-for="index in emptyStarCount" :key="index" class="star-rating__star icon-star_empty"></span>
    </span>
    <span v-if="showCount" class="star-rating__count">({{ count }})</span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

const LIMIT = 5;

export default Vue.extend({
  name: 'StarRating',
  props: {
    count: {
      type: Number!,
      required: true,
    },
    average: {
      type: Number!,
      required: true,
    },
    showCount: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    roundedStarRatingAvg(): number {
      return Math.round(this.average * 2) / 2.0;
    },
    ariaLabelForRatings(): string {
      if (this.showCount) {
        return `Rating: ${this.roundedStarRatingAvg} out of 5 stars. Total reviews: ${this.count}`;
      }
      return `Rating: ${this.roundedStarRatingAvg} out of 5 stars.`;
    },
    validAverage(): boolean {
      return this.average !== null || this.average < LIMIT || this.average > 0;
    },
    isAverageWholeNumber(): boolean {
      return this.average % 1 === 0;
    },
    fullStarCount(): number {
      return Math.floor(this.average);
    },
    fullStarMaxedOut(): boolean {
      return this.average === LIMIT;
    },
    hasHalfStar(): boolean {
      const decimal = Math.round(this.average % 1);
      return decimal === 0;
    },
    emptyStarCount(): number {
      if (this.fullStarMaxedOut) {
        return 0;
      }
      if (this.isAverageWholeNumber) {
        return LIMIT - this.fullStarCount;
      }
      return LIMIT - (this.fullStarCount + 1);
    },
  },
});
</script>
